import { SCROLL_COLLAPSE_EASING_DURATION_CLASS } from '~/components/ScrollCollapse/constants/classes';
import { useScrollCollapseContext } from '~/components/ScrollCollapse/hooks/useScrollCollapseContext';
import { cn } from '~/lib/cn';

/**
 * Create an opaque background that is taller than the table header to compensate for
 * the vertical spacing between the table rows created by the "border-spacing-y-sm" class.
 * The opaque background is invisible to the user because it matches the page background,
 * and prevents the table body from being visible behind the header as the page scrolls.
 */
export function TableHeaderBackground() {
  const { scrollProgress } = useScrollCollapseContext();
  const isHeaderCollapsed = scrollProgress > 1;

  return (
    <div
      className={cn(
        'absolute -inset-x-xl -bottom-sm -top-md -z-10 block border-b-px !bg-gradient bg-[length:100%,auto] bg-fixed bg-no-repeat will-change-[border-color] bg-level-01/full',
        SCROLL_COLLAPSE_EASING_DURATION_CLASS,
        {
          'border-transparent': !isHeaderCollapsed,
          'border-emphasis-subtle': isHeaderCollapsed,
        },
      )}
    />
  );
}

TableHeaderBackground.displayName = 'TableHeaderBackground';
